


































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import { collections } from "@/configs/firebase";
import logger from "@/configs/logger";
import { objectify } from "@/helpers";
import VerificationClaimAdmin from "@/components/Lead/VerificationClaimAdmin.vue";

@Component({ components: { VerificationClaimAdmin } })
export default class VerificationAdminView extends Vue {
  @Prop() agents!: any[];

  unsubscribe!: Function;
  dialog = false;
  selectedLead: any = null;
  pendingVerifications: any[] = [];

  @Watch("dialog")
  onDialogChange(val: boolean, prev: boolean) {
    // unselcet whenever dialog closes
    if (prev && !val) {
      this.selectedLead = null;
    }
  }

  get verificationAgents() {
    return this.agents.filter(agent => agent.roles.includes("verification"));
  }

  openVerAssignDialog(lead: any) {
    this.selectedLead = lead;
    this.dialog = true;
  }

  created() {
    this.getPendingVerification();
  }

  getPendingVerification() {
    this.unsubscribe && this.unsubscribe();
    this.unsubscribe = collections.lead
      .where("verification_requested", "==", true)
      .where("verification_completed", "==", false)
      .orderBy("verification_requested_ts", "desc")
      .onSnapshot(snapshot => {
        this.pendingVerifications = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        if (this.selectedLead) {
          const update = this.pendingVerifications.find(
            item => item.id == this.selectedLead.id
          );
          if (update) {
            this.selectedLead = update;
          }
        }
      });
  }

  getLeadDisplayId(lead: any): any {
    const firstName = lead.first_name || "";
    const lastName = lead.last_name || "";
    const phoneNumber = lead.phone_number || "";
    const leadSource = lead.lead_source || "";
    return `${firstName} ${lastName} ${lead.lead_source}`;
  }

  getAssignedCloser(lead: any) {
    if (lead) {
      const closer = objectify(lead.assigned_agent_email_by_role).closer;
      if (closer) {
        return closer.split("@")[0];
      }
    }
    return "n/a";
  }

  getAssignedVer(lead: any) {
    const ver = lead.verification_agent_email || "unassgined";
    return ver.split("@")[0];
  }

  getAssigButtonTitle(lead: any) {
    if (lead.verification_agent_email) {
      return "Reassign";
    }
    return "Assign";
  }

  getAssignButtonColor(lead: any) {
    const title = this.getAssigButtonTitle(lead);
    if (title == "Reassign") {
      return "red";
    }
    return "primary";
  }

  getBadgeColor(lead: any) {
    const agent =
      this.verificationAgents.find(
        agent => agent.email === lead.verification_agent_email
      ) || {};
    if (agent.available) {
      return "green";
    }
    return "grey";
  }
}
